import data from './countryData.json';

const hash = {};
data.forEach(item => {
  hash[`${item.value}${item.name}`] = item;
});
export const countryData = data;
export const countryHash = hash;

// const pushData = []
// // 爬https://countrycode.org/ 文档
// $('.main-table:eq(0) tr[data-index]').each(function () {
//   const $this = $(this);
//   const name = $this.find('td:eq(0)').text();
//   const value = `+${$this.find('td:eq(1)').text().replace(/-/g, '')}`
//   const key = $this.find('td:eq(2)').text().split('/')[0];
//   if (!xx.filter((data) => data.value === value).length) {
//     pushData.push({
//       "cnName": "",
//       key,
//       name,
//       value,
//       "icon": ""
//     })
//   }

// })
// console.log((pushData))

// 爬阿里云文档....的代码
// https://www.alibabacloud.com/help/zh/short-message-service/latest/dialing-codes
// const data = [];
// const $list = $('.tbody:eq(0)').find('tr');
// const length = $list.length;
// for (let i = 0; i < length; i++) {
//   const $item = $list.eq(i);
//   const cnName = $($item).find('td:eq(0)').text();
//   const name = $($item).find('td:eq(1)').text();
//   const key = $($item).find('td:eq(2)').text();
//   const value = '+' + $($item).find('td:eq(3)').text();
//   console.log(`${name}  ${value}` + '\n')
//   data.push({
//     cnName,key,name, value, icon: ''
//   })
// }
// console.log(JSON.stringify(data))

// 从emoji网站捞国旗....
// https://www.emojiall.com/zh-hans/sub-categories/J2
// const $list = $('.emoji_card')
// const length = $list.length;
// for (let i = 0; i < length; i++) {
//   const $item = $list.eq(i);
//   const emojivalue = $($item).find('a:eq(0)').text();
//   const name = $($item).find('a:eq(1)').text().replace(/旗: /g, '');
//   console.log(`${emojivalue}  ${name}`)
//   xx.forEach((data) => {
//     if (data.cnName === name) {
//       data.icon = emojivalue
//     }
//   })
// }
// console.log(JSON.stringify(xx))
